import React, { useEffect, useState } from 'react';
import { MapPinIcon, ChevronDownIcon, LoaderIcon } from 'lucide-react';
interface MobileDeliverToPillProps {
  selectedLocation: {
    name: string;
  } | null;
  onOpenLocationModal: () => void;
}
export function MobileDeliverToPill({
  selectedLocation,
  onOpenLocationModal
}: MobileDeliverToPillProps) {
  const [permissionDenied, setPermissionDenied] = useState(false);
  // Check if permission was previously denied
  useEffect(() => {
    const hasGrantedLocation = localStorage.getItem('hasGrantedLocation');
    if (hasGrantedLocation === 'denied') {
      setPermissionDenied(true);
    }
  }, []);
  const getDisplayText = () => {
    if (permissionDenied) return 'Enable Location';
    if (selectedLocation) return selectedLocation.name;
    return 'Select Location';
  };
  return <div className="md:hidden bg-white border-b border-gray-200" data-id="element-3067" data-mp="2fyfb1x1ot3h2">
      <div className="px-4 py-2" data-id="element-3068" data-mp="2b0dwnpf7hsbx">
        <button onClick={onOpenLocationModal} className="w-full h-10 bg-gray-50 hover:bg-gray-100 active:bg-gray-200 border border-gray-200 rounded-full flex items-center justify-between px-4 transition-all shadow-sm" role="button" aria-haspopup="dialog" aria-label="Change delivery location" aria-expanded="false" data-id="element-3069" data-mp="2b1f6xroeeasl">
          {/* Left side: Icon + Text */}
          <div className="flex items-center gap-2 min-w-0 flex-1" data-id="element-3070" data-mp="vmwpm0t3jhx">
            {/* Icon */}
            <MapPinIcon className="w-4 h-4 text-[#1E2B55] flex-shrink-0" data-id="element-3071" data-mp="olh6tvtqqtyh" />
            {/* Text */}
            <div className="flex items-center gap-1.5 min-w-0" data-id="element-3072" data-mp="tjismoijx7dn">
              <span className="text-xs text-gray-600 font-medium whitespace-nowrap" data-id="element-3073" data-mp="enjil8bvsx5v">
                Deliver to:
              </span>
              <span className="text-sm text-gray-900 font-semibold truncate" data-id="element-3074" data-mp="jka1s4izg8vi">
                {getDisplayText()}
              </span>
            </div>
          </div>
          {/* Right side: Arrow */}
          <ChevronDownIcon className="w-4 h-4 text-gray-500 flex-shrink-0 ml-2" data-id="element-3075" data-mp="34ddfhft55lqw" />
        </button>
      </div>
    </div>;
}